import prepareComponent from "@bluframe/grapple/prepareComponent"
import { useMemo } from "react"

import Overlay from "./Overlay"

export interface Props {
  children: React.ReactNode
  className?: string
  isOpen: boolean
  name?: string
  onClose?: () => void
}

export interface ComponentProps extends Props {
  label: string
}

export const usePrepareComponent = ({
  children,
  isOpen,
  name,
  onClose,
  ...props
}: Props): ComponentProps => {
  const label = useMemo(() => {
    if (name) return `${name} overlay`
    return "Overlay"
  }, [name])

  return {
    ...props,
    children,
    isOpen,
    label,
    name,
    onClose
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Overlay
)
